'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../../_rollupPluginBabelHelpers-273b5552.js');
var React = require('react');

var getTextRepresentation = function getTextRepresentation(node) {
  if (node == undefined) {
    // Return empty if not defined
    return '';
  } else if (_rollupPluginBabelHelpers._typeof(node) === 'object') {
    if (Array.isArray(node)) {
      // If it's an array, concatenate all the content
      return node.reduce(function (acc, child) {
        var representation = getTextRepresentation(child);
        if (representation) {
          if (acc) {
            return "".concat(acc, ", ").concat(representation);
          }
          return representation;
        }
        return acc;
      }, '');
    }
    if ('props' in node && 'children' in node.props) {
      // If it has children, traverse them
      return getTextRepresentation(node.props.children);
    }
  }
  // If all else fails, just stringify
  return node.toString();
};

/**
 * Traverses the input node and attempts to put together a
 *   string representation of it.
 *
 * @param node - Node to traverse
 * @returns - Our best guess of what it is in text
 */
var useTextRepresentation = function useTextRepresentation(node) {
  return React.useMemo(function () {
    return getTextRepresentation(node);
  }, [node]);
};

exports.useTextRepresentation = useTextRepresentation;
//# sourceMappingURL=index.js.map
